export let JWT_ALG = 'RS256'
export  { decodeJWT, createJWT, verifyJWT, Signer, JWTVerified, JWTHeader } from 'did-jwt-rsa'
